import React from 'react';
import { ICacheContext } from 'framework/context/ICacheContext';
import { IInventoryItemSearchData } from 'gen/ApiClient';

export const InventoryItemsFilterDataContext = React.createContext<ICacheContext<IInventoryItemSearchData>>(undefined as any);
